"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  return <section data-section-id="144413" id="hero" className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden dark bg-[#0f0f10]">
      <style>
        {`
          @keyframes slowPan {
            0% { transform: scale(1) translate(0, 0); }
            50% { transform: scale(1.05) translate(-1%, -1%); }
            100% { transform: scale(1) translate(0, 0); }
          }
          .animate-slow-pan {
            animation: slowPan 40s ease-in-out infinite;
          }
          
          @keyframes pulseGlow {
            0% { box-shadow: 0 0 10px 0px color-mix(in srgb, var(--color-primary) 40%, transparent); }
            50% { box-shadow: 0 0 25px 5px color-mix(in srgb, var(--color-primary) 60%, transparent); }
            100% { box-shadow: 0 0 10px 0px color-mix(in srgb, var(--color-primary) 40%, transparent); }
          }
          .animate-pulse-glow {
            animation: pulseGlow 3s infinite;
          }
        `}
      </style>

      {}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/tech_circuit_board_pattern_hero.png" alt="Abstract digital circuit pattern background" className="w-full h-full object-cover animate-slow-pan opacity-20" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-[radial-gradient(circle_at_top_right,_rgba(61,193,188,0.12),_transparent_50%),radial-gradient(circle_at_bottom_left,_rgba(15,26,26,0.8),_transparent_60%)] backdrop-blur-[1px]"></div>

      {}
      <div className="relative z-20 flex flex-col items-center text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto mt-16 transition-all duration-700 ease-out translate-y-0">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-sans font-extrabold text-[#3dc1bc] tracking-[-0.02em] mb-6 leading-tight drop-shadow-[0_0_15px_rgba(61,193,188,0.4)]">
          Professional Websites for Your Network, Rewards for You.
        </h1>
        
        <p className="text-lg md:text-xl font-sans font-normal text-cyan-50/70 max-w-2xl mb-10 drop-shadow-md">
          Partner with us to deliver high-performance digital solutions to your clients while earning industry-leading recurring commissions.
        </p>
        
        <Link to="/ContactPage">
          
        </Link>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2 text-cyan-100/60">
        <span className="text-xs font-bold tracking-[0.2em] uppercase opacity-70">Scroll to Explore</span>
        <div className="animate-bounce mt-1">
          <ArrowDown className="w-5 h-5 text-[#3dc1bc] animate-pulse" strokeWidth={2} />
        </div>
      </div>
    </section>;
}